import { PAIR_BLACKLIST, TOKEN_BLACKLIST } from 'constants/info'
import React, { Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import { isAddress } from 'utils/info'
import GoogleAnalyticsReporter from '../components/analytics/GoogleAnalyticsReporter'
import Header from '../components/Header'
import Polling from '../components/Header/Polling'
import URLWarning from '../components/Header/URLWarning'
import Popups from '../components/Popups'
import Web3ReactManager from '../components/Web3ReactManager'
import DarkModeQueryParamReader from '../theme/DarkModeQueryParamReader'
import AddLiquidity from './AddLiquidity'
import {
  RedirectDuplicateTokenIds,
  RedirectOldAddLiquidityPathStructure,
  RedirectToAddLiquidity
} from './AddLiquidity/redirects'
import Pool from './Pool'
import PoolFinder from './PoolFinder'
import RemoveLiquidity from './RemoveLiquidity'
import { RedirectOldRemoveLiquidityPathStructure } from './RemoveLiquidity/redirects'
import Swap from './Swap'
import { RedirectPathToSwapOnly, RedirectToSwap } from './Swap/redirects'
import PairPage from './Pair'
import TokenPage from './Token'
import PageTokens from './Tokens'
import KycStatus from 'components/KycStatus'
import FaqPage from './FAQ'
// import PageTokenomics from './Tokenomics'
// import PageCommunity from './Community'
// import PageTrade from './Trade'
// import PageBribe from './Bribe'
// import Earn from './Earn'
// import Manage from './Earn/Manage'
// import MigrateV1 from './MigrateV1'
// import MigrateV1Exchange from './MigrateV1/MigrateV1Exchange'
// import RemoveV1Exchange from './MigrateV1/RemoveV1Exchange'
// import Vote from './Vote'
// import VotePage from './Vote/VotePage'
// import { PAIR_BLACKLIST, TOKEN_BLACKLIST } from 'constants/info'
// import AddressClaimModal from '../components/claim/AddressClaimModal'
// import { ApplicationModal } from '../state/application/actions'
// import { useModalOpen, useToggleModal } from '../state/application/hooks'
// import { OpenClaimAddressModalAndRedirectToSwap, RedirectPathToSwapOnly, RedirectToSwap } from './Swap/redirects'

const AppWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  overflow-x: hidden;
  min-height: 100vh;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 50px 15px 40px 15px;
  align-items: center;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 10;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 16px;
    padding-top: 2rem;
  `};

  z-index: 1;

  background: url('/images/bg-main.webp');
  background-size: contain;
  background-repeat: no-repeat;
`

const Marginer = styled.div`
  margin-top: 5rem;
`

// function TopLevelModals() {
//   const open = useModalOpen(ApplicationModal.ADDRESS_CLAIM)
//   const toggle = useToggleModal(ApplicationModal.ADDRESS_CLAIM)
//   return <AddressClaimModal isOpen={open} onDismiss={toggle} />
// }

export default function App() {
  return (
    <Suspense fallback={null}>
      <Route component={GoogleAnalyticsReporter} />
      <Route component={DarkModeQueryParamReader} />
      <AppWrapper>
        <URLWarning />

        <Header />

        <BodyWrapper>
          <Popups />
          <Polling />
          {/* <TopLevelModals /> */}
          <Web3ReactManager>
            <>
              <KycStatus />
              <Switch>
                <Route exact strict path="/swap" component={Swap} />
                <Route exact strict path="/swap/:outputCurrency" component={RedirectToSwap} />
                <Route exact strict path="/send" component={RedirectPathToSwapOnly} />
                <Route exact strict path="/find" component={PoolFinder} />
                <Route exact strict path="/pool" component={Pool} />
                <Route exact strict path="/tokens" component={PageTokens} />
                {/* <Route exact strict path="/uni" component={Earn} /> */}
                {/* <Route exact strict path="/claim" component={OpenClaimAddressModalAndRedirectToSwap} /> */}
                {/* <Route exact strict path="/tokenomics" component={PageTokenomics} /> */}
                {/* <Route exact strict path="/bribe" component={PageBribe} /> */}
                {/* <Route exact strict path="/vote" component={Vote} /> */}
                <Route exact strict path="/create" component={RedirectToAddLiquidity} />
                <Route exact path="/add" component={AddLiquidity} />
                <Route exact path="/add/:currencyIdA" component={RedirectOldAddLiquidityPathStructure} />
                <Route exact path="/add/:currencyIdA/:currencyIdB" component={RedirectDuplicateTokenIds} />
                <Route exact path="/create" component={AddLiquidity} />
                <Route exact path="/create/:currencyIdA" component={RedirectOldAddLiquidityPathStructure} />
                <Route exact path="/create/:currencyIdA/:currencyIdB" component={RedirectDuplicateTokenIds} />
                {/* <Route exact strict path="/remove/v1/:address" component={RemoveV1Exchange} /> */}
                <Route exact strict path="/remove/:tokens" component={RedirectOldRemoveLiquidityPathStructure} />
                <Route exact strict path="/remove/:currencyIdA/:currencyIdB" component={RemoveLiquidity} />
                {/* <Route exact strict path="/migrate/v1" component={MigrateV1} /> */}
                {/* <Route exact strict path="/migrate/v1/:address" component={MigrateV1Exchange} /> */}
                {/* <Route exact strict path="/uni/:currencyIdA/:currencyIdB" component={Manage} /> */}
                {/* <Route exact strict path="/vote/:id" component={VotePage} /> */}
                {/*<Route exact strict path="/community" component={PageCommunity} />*/}
                <Route exact strict path="/faq" component={FaqPage} />
                {/* <Route exact path="/community/:secret" component={PageCommunity} /> */}
                <Route
                  exact
                  strict
                  path="/token/:tokenAddress"
                  render={({ match }) => {
                    if (
                      isAddress(match.params.tokenAddress.toLowerCase()) &&
                      !Object.keys(TOKEN_BLACKLIST).includes(match.params.tokenAddress.toLowerCase())
                    ) {
                      return <TokenPage address={match.params.tokenAddress.toLowerCase()} />
                    } else {
                      return <Redirect to="/" />
                    }
                  }}
                />
                <Route
                  exact
                  strict
                  path="/pair/:pairAddress"
                  render={({ match }) => {
                    if (
                      isAddress(match.params.pairAddress.toLowerCase()) &&
                      !Object.keys(PAIR_BLACKLIST).includes(match.params.pairAddress.toLowerCase())
                    ) {
                      return <PairPage pairAddress={match.params.pairAddress.toLowerCase()} />
                    } else {
                      return <Redirect to="/" />
                    }
                  }}
                />
                {/* <Route exact strict path="/trade" component={PageTrade} />
                <Route
                  exact
                  strict
                  path="/trade/:inputCurrency/:outputCurrency"
                  render={({ match }) => {
                    if (
                      isAddress(match.params.inputCurrency.toLowerCase()) &&
                      !Object.keys(TOKEN_BLACKLIST).includes(match.params.inputCurrency.toLowerCase()) &&
                      isAddress(match.params.outputCurrency.toLowerCase()) &&
                      !Object.keys(TOKEN_BLACKLIST).includes(match.params.outputCurrency.toLowerCase())
                    ) {
                      return <PageTrade />
                    } else {
                      return <Redirect to="/trade" />
                    }
                  }}
                /> */}
                <Route component={RedirectPathToSwapOnly} />
              </Switch>
            </>
          </Web3ReactManager>
          <Marginer />
        </BodyWrapper>
      </AppWrapper>
    </Suspense>
  )
}
